<template>
  <div class="word-exam-dialog dialog">
    <div class="content">
      <div class="close"></div>
      <div class="title"></div>
      <div class="main">
        <div class="word-centent">
          <div class="name">{{ wordExamInfo.title }}</div>
          <div class="hint">请选择测试内容</div>
          <div class="radio-grop">
            <el-radio-group class="radio-group" v-model="wordExamType">
              <el-radio
                v-for="(type, index) in wordExamInfo.list"
                :key="index"
                :label="type.label"
              >
                <template v-if="type.label === 'day_learn'"
                  >今日新学（{{ type.value }}个）</template
                >
                <template v-else-if="type.label === 'already_unit_learn'">
                  已学（{{ type.value }}个）
                </template>
                <template v-else>单元卷（{{ type.value }}个）</template>
                <template></template>
                <template></template>
              </el-radio>
            </el-radio-group>
          </div>
          <div class="btn-control">
            <el-button
              :disabled="wordExamCount === 0 || !currentWordExam.status"
              @click="onlineWordExam('online')"
              type="primary"
              >在线测试</el-button
            >
            <template v-if="wordExamType !== 'all_unit_learn'">
              <el-button
                :disabled="wordExamCount === 0 || !currentWordExam.status"
                @click="selectDownloadExamType('download')"
                type="primary"
                >下载试卷</el-button
              >
            </template>
            <template v-else>
              <el-button
                :disabled="wordExamCount === 0"
                @click="selectDownloadExamType('download_learn_before')"
                type="primary"
                >下载学前测试卷</el-button
              >
              <el-button
                :disabled="wordExamCount === 0"
                @click="selectDownloadExamType('download_learn_after')"
                type="primary"
                >下载学后测试卷</el-button
              >
              <el-button
                :disabled="wordExamCount === 0"
                @click="onlineWordExam('unit_dictation')"
                type="primary"
                >单元听写</el-button
              >
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Button,
  Radio,
  RadioGroup,
} from 'element-ui';
import api from '@/api/graphql/englishCourse';

export default {
  components: {
    ElButton: Button,
    ElRadio: Radio,
    ElRadioGroup: RadioGroup,
  },
  props: {
    course: {
      type: Object,
      default: () => {},
    },
    unit: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    courseId() {
      return this.course.id;
    },
    unitId() {
      return this.unit.id;
    },
  },
  data() {
    return {
      wordExamInfo: [],
      wordExamType: '',
      wordExamCount: 0,
    };
  },
  created() {
    this.getExamModelList();
  },
  methods: {
    getExamModelList() {
      api.getExamModelList({
        courseId: this.courseId,
        unitId: this.unitId,
      }).then(({ englishExamModelList }) => {
        this.wordExamInfo = englishExamModelList;
        if (this.wordExamInfo.list.length) {
          this.wordExamType = this.wordExamInfo.list[0].label;
          this.wordExamCount = this.wordExamInfo.list[0].value;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "@/styles/common/dialog.scss";
  @import '@/styles/variables.scss';
  .word-exam-dialog {
    width: 150vh;
    height: 90vh;
  }
</style>
